<script lang="ts">
  import {
    SkipToContent,
    Header,
    HeaderUtilities,
    HeaderGlobalAction,
  } from "carbon-components-svelte";

  import UserAvatar20 from "carbon-icons-svelte/lib/UserAvatar20";
  import Logout20 from "carbon-icons-svelte/lib/Logout20";
  import Moon20 from "carbon-icons-svelte/lib/Moon20";
  import ArrowsVertical from "carbon-icons-svelte/lib/ArrowsVertical20";

  import { createEventDispatcher } from 'svelte'

  import HeaderUser from './HeaderUser.svelte'
  import HeaderConnectivity from './HeaderConnectivity.svelte'

  const dispatch = createEventDispatcher<{ toggleTheme: void }>()

  import { getContext } from "svelte";

  import ConnectionStore from '../stores/connection'

  const { loggedIn, username, pingCount } = ConnectionStore

  const doLogout = () => ConnectionStore.logout()

  const ctx: { updateVar: any } = getContext("Theme");
  $: if (ctx) {
    ctx.updateVar("--cds-productive-heading-06-font-size", "4rem");
  }
  function toggleTheme() {
    dispatch('toggleTheme')
  }
</script>

<Header company="Cardodrom" platformName="Web Edition" href="/">
  <div slot="skip-to-content">
    <SkipToContent />
  </div>
  <HeaderUtilities>
    <HeaderConnectivity aria-label="connectivity" pingCount={$pingCount} icon={ArrowsVertical} />
    {#if $loggedIn}
      <HeaderUser aria-label="User" name={$username} icon={UserAvatar20} />
      <HeaderGlobalAction on:click={doLogout} aria-label="Logout" icon="{Logout20}" />
    {/if}
    <HeaderGlobalAction on:click={toggleTheme} aria-label="Logout" icon="{Moon20}" />
  </HeaderUtilities>
</Header>

<style>
  :global(.bx--header__menu-trigger.bx--header__menu-toggle) {
    display: none;
  }
</style>
